import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';


export interface DialogData {
    message: any;
}

@Component({
    selector: 'app-view-message-tts',
    templateUrl: './view-message-tts.component.html',
    styleUrls: ['./view-message-tts.component.scss']
})
export class ViewMessageTtsComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<ViewMessageTtsComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
    ) { }

    ngOnInit() {
    }

    onNoClick(): void {

        this.dialogRef.close();
    }

}
